let chatwayScriptInjected = false;

/** Loads Chatway the same way as a pasted snippet: one async script on `document.body`. */
const injectChatway = (widgetId: string) => {
  if (!widgetId || typeof document === 'undefined') return;
  if (chatwayScriptInjected) return;
  chatwayScriptInjected = true;

  const script = document.createElement('script');
  script.async = true;
  script.id = 'chatway';
  script.src = `https://cdn.chatway.app/widget.js?id=${widgetId}`;
  script.onload = () => window.dispatchEvent(new Event('chatwayWidgetDidInit'));
  document.body.appendChild(script);
};

export default injectChatway;
